export default {
    no: {
        // Page
        pageTitle:                   'Thon Innsyn',
        // Header
        headerTitle:                 'Henvendelser',
        // Confirm
        confirmTitle:                'Skjemaet er sendt!',
        confirmInfoFirst:            'Vi takker for din henvendelse til Thon Gruppen og vil gi deg en tilbakemelding innen 30 dager.',
        confirmInfoSecond:           'For mer informasjon om personvern i Thon Gruppen, vennligst se vår personvernerklæring på ',
        confirmSubmit:               'Send inn et nytt skjema',
        // Contact form labels
        formLabelName:              'Navn',
        formLabelEmail:             'E-postadresse',
        formLabelPhone:             'Telefonnummer',
        // Contact form placeholders
        formPlaceholderName:        'Skriv inn ditt navn',
        formPlaceholderEmail:       'Skriv inn din e-postadresse',
        formPlaceholderPhone:       'Skriv inn ditt telefonnummer',
        formSubmit:                 'Send skjema',
        // Inquiry Types
        inquiryTypeRequest:          'Type forespørsel',
        inquiryPetition:             'Innsyn',
        inquiryPetitionText:         'Du har rett til å få tilgang til og informasjon om de personopplysningene som vi har lagret om deg. Dette inkluderer blant annet hvilken type data som blir behandlet, hvorfor den blir behandlet, og hvem opplysningene eventuelt blir delt med.',
        inquiryPetitionPh:           'Beskriv mer detaljert hvilket område du ønsker innsyn i, f.eks. kjøpesenter du er medlem i...',
        inquiryCorrectInfo:          'Rette',
        inquiryCorrectInfoText:      'Du har rett til å korrigere unøyaktige eller ufullstendige personopplysninger om deg selv som vi har lagret. Dette sikrer at opplysningene dine er oppdaterte og korrekte.',
        inquiryCorrectInfoPh:        'Beskriv mer detaljert hvilket område du ønsker å rette i, f.eks. kjøpesenter du er medlem i...',
        inquiryPersonalInfo:         'Slette',
        inquiryPersonalInfoText:     'Du har rett til å be om at vi fjerner alle personopplysninger vi har lagret om deg. Dette er også kjent som "retten til å bli glemt", og sikrer at individets personlige data ikke lenger blir behandlet av organisasjonen, med mindre det foreligger annen lovlig grunn til å beholde dataene.',
        inquiryPersonalInfoPh:       'Beskriv mer detaljert hvilke opplysninger som skal slettes, f.eks. fra hvilket kjøpesenter du er medlem i...',
        inquiryAutomatedProcesses:   'Automatiserte avgjørelser og profilering',
        inquiryAutomatedProcessesText: 'Du har rett til å bli informert om og motsette deg beslutninger som utelukkende tas på grunnlag av automatiserte prosesser, da inkludert profilering. Du har også rett til å forstå hvordan dine personopplysninger brukes til profilering.',
        inquiryAutomatedProcessesPh: '',
        inquiryOther:                'Andre henvendelser',
        inquiryOtherText:            'Om du ikke synes din henvendelse passer inn i noen av de andre skjemaene, men du har en GDPR-henvendelse. Vennligst benytt boksen under for beskrivelse av din henvendelse.',
        inquiryOtherPh:              'Beskriv kort hva din henvendelse gjelder...',
        here: ' her',
        inquiryTypeInfoText: 'Begrepene ovenfor er hentet fra lovverkets definisjon av de ulike rettighetene du har som registrert. Dersom du ønsker forklaring av disse begrepene slik at du forstår hvilket du skal velge henviser vi til Datatilsynets forklaring av dine rettigheter. Vennligst trykk',
        inquiryTypeInfoText2: ' for Datatilsynets forklaring.',
        // Target Systems
        systemsLabel:               'Velg ett eller flere områder:',
        systemGuestProfile:         'Gjesteprofil på hotell',
        systemThonPlus:             'THON+ (medlemskap Thon Hotels)',
        systemCustomerClub:         'Kundeklubb kjøpesenter',
        systemThonEiendom:          'Thon Eiendom',
        systemTimePark:             'Time Park',
        systemRecruitment:          'Rekruttering',
        systemOther:                'Annet',
        // Inquiry form
        inquiryFormConsent:         'Jeg ønsker i tillegg informasjon om sikkerhetstiltak knyttet til deres bruk av personopplysninger om meg.',
        submitNext:                 'Gå videre',
        inquiryFormPlaceholder:     'Fritekst',
        // Validation text
        checkboxOrTextRequired:     'Huk av for valg eller skriv i fritekstområdet',
        checkboxRequired:           'Du må huke av for minst ett valg',
        textRequired:               'Tekst er påkrevd',
        nameRequired:               'Navn er påkrevd',
        emailRequired:              'E-postadresse er påkrevd',
        phoneRequired:              'Telefonnummer er påkrevd',
        invalidEmail:               'Ugyldig e-postadresse',
        invalidCharacters:          'Ugyldige tegn',
        invalidZipCode:             'Ugyldig postnummer',
        invalidPhone:               'Ugyldig telefonnummer',
        invalidDate:                'Ugyldig dato',
        // Verify phone number
        verifyPhoneHeading:         'Bekreft mobilnummer',
        verificationCodeLabel:      'Verifiseringskode',
        verificationCodePlaceholder:'Skriv inn verifiseringskoden',
        verificationCodeRequired:   'Verifiseringskoden er påkrevd',
        sendNewCode:                'Send en ny kode',
        wrongCode:                  'Feil kode, prøv igjen'
    },
    en: {
        // Page
        pageTitle:                   'Thon Privacy',
        // Header
        headerTitle:                 'Privacy Policy Form',
        // Confirm
        confirmTitle:                'The form has been sent!',
        confirmInfoFirst:            'We thank you for your inquiry to the Thon Group. We will get back to you within 30 days',
        confirmInfoSecond:           'For more information about privacy within the  Thon Group, please see our privacy statement at ',
        // Contact form labels
        formLabelName:              'Name',
        formLabelEmail:             'E-mail',
        formLabelPhone:             'Phone',
        // Contact form placeholders
        formPlaceholderName:        'Enter your name',
        formPlaceholderEmail:       'Enter your e-mail',
        formPlaceholderPhone:       'Enter your phonenumber',
        formSubmit:                  'Submit form',
        // Inquiry Types
        inquiryTypeRequest:          'Type of request',
        inquiryPetition:             'Access to information',
        inquiryPetitionText:         'You have the right to access and get an overview regarding the personal data that we have stored about you. This includes the categories of personal data that is processed, the purpose of the processing and with whom the information is shared.',
        inquiryPetitionPh:           'Describe in more detail which area you want access to, e.g. shopping center you are a member of...',
        inquiryCorrectInfo:          'Rectification',
        inquiryCorrectInfoText:      'You have the right to correct inaccurate or incomplete personal data about yourself that we have stored. This ensures that your information is up-to-date and correct.',
        inquiryCorrectInfoPh:        'Describe in more detail which area you want to correct information in, e.g. shopping center you are a member of...',
        inquiryPersonalInfo:         'Erasure',
        inquiryPersonalInfoText:     'You have the right to request that we remove all personal data we have stored about you. This is also known as the "right to be forgotten" and ensures that the individual\'s personal data is no longer processed by the organization unless there is another legal reason to retain the data.',
        inquiryPersonalInfoPh:       'Describe in more detail which information you want deleted, e.g. from which shopping center you are a member of...',
        inquiryAutomatedProcesses:   'Automated individual decision-making and profiling',
        inquiryAutomatedProcessesText: 'You have the right to be informed about and to object to decisions made solely based on automated processes, including profiling. You also have the right to understand how your personal data is being used for profiling.',
        inquiryAutomatedProcessesPh: '',
        inquiryOther:                'Other',
        inquiryOtherText:            'If you believe your inquiry doesn\'t align with any of the provided forms, yet it pertains to GDPR, please proceed your inquiry below.',
        inquiryOtherPh:              'Briefly describe what your inquiry concerns...',
        inquiryTypeInfoText: 'The terms above are derived from the statutory definition of the different rights you have. If you wish to read an explanation of these terms so that you understand which one to choose, we refer to GDPR chapter 3, article 12-22. Please click ',
        here: ' here',
        inquiryTypeInfoText2: ' to read chapter 3 of GDPR.',
        // Target Systems
        systemsLabel:               'Select one or more areas:',
        systemGuestProfile:         'Hotel guest profile',
        systemThonPlus:             'THON+ (Membership Thon Hotels)',
        systemCustomerClub:         'Membership shopping Center',
        systemThonEiendom:          'Thon Eiendom',
        systemTimePark:             'Time Park',
        systemRecruitment:          'Recruitment',
        systemOther:                'Other',
        // Inquiry form
        inquiryFormConsent:         'I also want information about security measures related to the use of my personal information.',
        submitNext:                 'Next step',
        inquiryFormPlaceholder:     'Free text',
        // Validation text
        checkboxOrTextRequired:     'Check a choice or write in the free text area',
        checkboxRequired:           'You must check at least one option',
        textRequired:               'Text is required',
        nameRequired:               'Name is required',
        emailRequired:              'E-mail is required',
        phoneRequired:              'Phone number is required',
        invalidEmail:               'Invalid email',
        invalidCharacters:          'Invalid characters',
        invalidZipCode:             'Invalid zip code',
        invalidPhone:               'Invalid phone number',
        invalidDate:                'Invalid date',
        // Verify phone number
        verifyPhoneHeading:         'Verify phone number',
        verificationCodeLabel:      'Verification code',
        verificationCodePlaceholder:'Enter the verification code',
        verificationCodeRequired:   'Verification code is required',
        sendNewCode:                'Send a new code',
        wrongCode:                  'Wrong code, try again'
    }
}